// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__3CA1A","blog":"styles_blog__3VkZ9","bigmongolian":"styles_bigmongolian__3DcZQ","geekflare":"styles_geekflare__1bGbl"};